<div class="tabs {{ tabStyle }}">
  <div
    *ngFor="let tab of tabs"
    class="tabs__item {{ tab.status ? 'tabs__item--' + tab.status : '' }}"
    [class.vertical__item]="tabStyle == tabStyleEnum.vertical"
    [ngClass]="{
      'tabs__item--active': !tab.link && tabStyle == tabStyleEnum.default ? tab.active : false,
      'tabs__item--vertical-active': !tab.link && tabStyle == tabStyleEnum.vertical ? tab.active : false,
      'tabs__item--disabled': tab.disabled
    }"
    [routerLink]="tab.link ? tab.link : []"
    [routerLinkActive]="tab.link ? tabStyle == tabStyleEnum.default ?  'tabs__item--active' : 'tabs__item--vertical-active' : ''"
    (click)="!tab.disabled && selectTab(tab.id)"
  >
    <i *ngIf="tab.icon" [class]="tab.icon"></i>
    <ng-container *ngIf="!tab.templateRef "> 
      {{ tab.heading }}

      <!-- default counter -->
      <ng-container *ngIf="counterStyle == counterStyleEnum.default">
        <span *ngIf="tab.counter > 0 || tab?.showCountAlways" class="tabs__item_counter">{{ tab.counter }}</span>
      </ng-container>

      <!-- counter with error -->
      <ng-container *ngIf="!tab.templateRef && counterStyle == counterStyleEnum.withError">
        <div class="tabs__item_count-with-error">
          <span *ngIf="tab?.counter > 0 || tab?.showCountAlways">{{ tab?.counter }}</span>
          <div class="divider" *ngIf="tab?.counter > 0 && tab?.errorCounter > 0"></div>
          <span class="error" *ngIf="tab?.errorCounter > 0">{{ tab?.errorCounter }}</span>
        </div>
      </ng-container>
    </ng-container>

    <!-- pass the template for any different style of heading and counter -->
    <ng-container *ngIf="tab.templateRef">
      <template [ngTemplateOutlet]="tab.templateRef"></template>
    </ng-container>
    
  </div>
</div>
<ng-content *ngIf="hasContent"></ng-content>
